<div class="dialog">
  @if (step === 'intro') {
    <div mat-dialog-title>Combine Orders
      @if (step!=='show-progress-bar' || (step==='show-progress-bar' && isShowProgressBarButtons)) {
        <button class="close" mat-button title="Cancel"
          (click)="close()"><i class="material-icons clear" >clear</i></button>
        }
      </div>
      <div class="dialog-body">
        @if (showSpinner) {
          <div class="loading-spinner"></div>
        }
        @if (!showSpinner) {
          <mat-dialog-content>
            <div>
              <div class="block">This feature allows you to combine similar orders into a block trade.
                If you continue, all orders (or all selected orders) that are identical in the following fields will
              be combined into one block order: transaction type, symbol, order type, limit price, stop price, and expiration.</div>
              <div class="block">If the block order is completely filled, the allocation will be sent automatically.</div>
              <div class="block">If the allocation is partially filled, you will be required to allocate the executed order on SAC, which you can submit from the equity allocations screen after execution of the block order.</div>
              <div class="block">(It is strongly recommended that you subscribe to the Unallocated Trade Alert in SAC to notify you when an allocation is pending after market close.)</div>
              <div>If you would like to continue please select a master account.
                <div class="right">
                  <span class="item-label bold" style="margin-right: 10px">Master Account</span>
                  <irb-dropdown-filter #masterAccountTemplateRef
                    (search)="getMasterAccount($event)"
                    [(value)]="selectedMasterAccount"
                    size="13" hoverPanelWidth="155"
                    (selection)="selectOption($event)">
                  </irb-dropdown-filter>
                </div>
              </div>
            </div>
          </mat-dialog-content>
        }
      </div>
      <mat-dialog-actions>
        <button id="closeButton" (click)="close()" class="btn-medium-secondary">Discontinue block</button>
        <button id="continueButton" (click)="btnProceedCombineHandler()" class="btn-medium-primary" [disabled]="canNotContinue || showSpinner">Proceed</button>
      </mat-dialog-actions>
    }
    @if (step === 'show-combine-warning') {
      <div class="irb-dialog">
        <div mat-dialog-title>{{combinedWarningTitle || 'Combine Orders'}}</div>
        <mat-dialog-content>
          <mat-card class="block warn">
            <mat-card-title style="white-space: pre-line;">{{combinedWarningMsg}}</mat-card-title>
          </mat-card>
          @if (combinedWarningAltMsg) {
            <div style="white-space: pre-line;">{{combinedWarningAltMsg}}</div>
          }
        </mat-dialog-content>
        <mat-dialog-actions>
          @if (combinedWarningCallbackFn === undefined) {
            <button id="cancelButtonWarningNoCallback"class="secondaryButton" class="btn-medium-secondary" (click)="close()">{{'Discontinue block'}}</button>
          }
          @if (combinedWarningCallbackFn !== undefined) {
            <button id="cancelButtonWarningCallback" [disabled]="showSpinner" class="secondaryButton" class="btn-medium-secondary" (click)="combinedWarningCancelCallbackFn()">{{combinedWarningCancelBtnTitle || 'Discontinue block'}}</button>
          }
          @if (combinedWarningCallbackFn !== undefined) {
            <button id="continueButtonWarning" [disabled]="showSpinner" class="primaryButton" class="btn-medium-primary" (click)="combinedWarningCallbackFn($event)">{{combinedWarningBtnTitle || 'Continue'}}</button>
          }
        </mat-dialog-actions>
      </div>
    }
    @if (step === 'show-unblock-orders') {
      <div class="irb-dialog">
        <div mat-dialog-title>Unblock Orders</div>
        @if (showSpinner) {
          <div class="loading-spinner"></div>
        }
        @if (!showSpinner) {
          <mat-dialog-content class="dialog-content">
            @if (unblockOrdersArr.length === 0) {
              <div>{{'0 selected orders will be unblocked.'}}
              </div>
            }
            @if (unblockOrdersArr.length > 0) {
              <div>
                {{unblockOrdersArr.length + ' of ' + selectedArray.length + ' selected orders can be unblocked.' +
                '&nbsp;Orders within these blocks will revert to single-account orders.'}}
              </div>
            }
            @if (unblockOrdersArr?.length > 0) {
              <div class="unblockOrderTable">
                @if (!isUiTest) {
                  <irb-inventory-grid
                    [style.height]="'240px'"
                    [gridOptions]="unblockGridOptions"
                    [rowData]="unblockOrdersRowData">
                  </irb-inventory-grid>
                }
              </div>
            }
          </mat-dialog-content>
        }
        <mat-dialog-actions>
          @if (btnUnblockCancelShow) {
            <button id="cancelButtonUnblockOrder" (click)="close()" class="btn-medium-secondary">Cancel</button>
          }
          @if (btnUnblockCloseShow) {
            <button id="closeButtonUnblockOrder" (click)="close()" class="btn-medium-secondary">Close</button>
          }
          @if (btnRevertBlockShow) {
            <button id="proceedButtonUnblockOrder" (click)="btnRevertBlockHandle()" class="btn-medium-primary" [disabled]="canNotContinue">Proceed</button>
          }
        </mat-dialog-actions>
      </div>
    }
    @if (step === 'show-progress-bar') {
      <div mat-dialog-title>Create Blocks</div>
      <div class="dialog-body flex progress-bar">
        <irb-progress-bar [progressValue]="inventoryComponentRef.pfs.progressBarValue"></irb-progress-bar>
      </div>
      @if (isShowProgressBarButtons) {
        <mat-dialog-actions>
          <button id="closeButtonProgressBar" class="btn-medium-primary" (click)="close()">Close</button>
        </mat-dialog-actions>
      }
    }
  </div>
